<template>
  <div v-if="item" class="grid gap-3 p-3">
    <!-- {{ item }} -->
    <div class="flex justify-between items-center border-b pb-2">
      <div>
        <h6
          class="mb-0 mobile:text-[15px] tablet:text-[16px] largeDesktop:text-[18px] font-medium font-roboto text-red-400"
>
          Plan Amount
        </h6>
        <h4
          class="mb-0 mobile:text-[26px] tablet:text-[28px] largeDesktop:text-[36px] font-bold font-roboto text-black-100"
>
          ${{ $helper.formatAmount(item.total_amount) }}<span
            class="mobile:text-[20px] tablet:text-[22px] largeDesktop:text-[30px]"
>/{{
              item.payment_term_slug === 'yearly' ? 'yr' : 'mo'
            }}</span>
        </h4>
      </div>
      <img
:src="getStatusImage(item.status_slug)" alt="Approved Icon"
        class="mobile:w-6 mobile:h-6 tablet:w-8 tablet:h-8 object-contain"
>
    </div>
    <div class="flex justify-between items-center border-b pb-2">
      <div>
        <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-red-400">
          Sale Date
        </h6>
        <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
          {{ $helper.isEmpty(item.sale_date) ? '-' : $helper.formatDateTime(item.sale_date) }}
        </h4>
      </div>
      <div>
        <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-lime-600">
          Approved Date
        </h6>
        <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
          {{ $helper.isEmpty(item.approved_at) ? '-' : $helper.formatDateTime(item.approved_at) }}
        </h4>
      </div>
    </div>
    <div class="flex justify-between items-center border-b pb-2">
      <div>
        <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-red-400">
          ID
        </h6>
        <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
          {{ item.id }}
        </h4>
      </div>
      <div>
        <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-red-400">
          SRO Number
        </h6>
        <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
          {{ $helper.isEmpty(item.sro_number) ? '-' : item.sro_number }}
        </h4>
      </div>
      <div>
        <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-red-400">
          Qty
        </h6>
        <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
          {{ item.quantity }}
        </h4>
      </div>
    </div>
    <div class="flex flex-col border-b pb-2">
      <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-red-400">
        Plan Name
      </h6>
      <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
        {{ $helper.isEmpty(item.plan_name) ? '-' : item.plan_name }}
      </h4>
    </div>
    <div class="flex flex-col border-b pb-2">
      <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-red-400">
        Consumer Name
      </h6>
      <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
        {{ $helper.isEmpty(item.consumer_name) ? '-' : item.consumer_name }}
      </h4>
    </div>
    <div class="flex justify-between items-center border-b pb-2">
      <div>
        <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-red-400">
          Phone Number
        </h6>
        <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
          {{ $helper.isEmpty(item.consumer_phone) ? '-' : $helper.formatPhoneNumber(item.consumer_phone) }}
        </h4>
      </div>
      <div class="hidden tablet:block">
        <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-red-400">
          Email
        </h6>
        <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
          {{ $helper.isEmpty(item.consumer_email) ? '-' : item.consumer_email }}
        </h4>
      </div>
    </div>
    <div class="tablet:hidden border-b pb-2">
      <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-red-400">
        Email
      </h6>
      <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
        {{ $helper.isEmpty(item.consumer_email) ? '-' : item.consumer_email }}
      </h4>
    </div>
    <div class="flex flex-col border-b pb-2">
      <h6 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-red-400">
        Address
      </h6>
      <h4 class="mb-0 mobile:text-[14px] tablet:text-[16px] font-medium font-roboto text-gray-900">
        {{ $helper.isEmpty(item.consumer_address) ? '-' : item.consumer_address }}
      </h4>
    </div>
    <div v-if="false" class="flex justify-center items-center gap-3 mt-3">
      <!-- <span
        class="px-3 py-2.5 text-[14px] rounded-md leading-none cursor-pointer transition-all border-1 !border-purple-400 text-purple-400 hover:bg-purple-400 hover:text-white">See
        Work History</span>
      <span
        class="px-3 py-2.5 text-[14px] rounded-md leading-none cursor-pointer transition-all border-1 !border-purple-400 text-purple-400 hover:bg-purple-400 hover:text-white">See
        Commissions</span> -->
      <span
        class="px-3 py-2.5 text-[14px] rounded-md leading-none cursor-pointer transition-all border-1 bg-gray-300 text-white"
>See
        Work History</span>
      <span
        class="px-3 py-2.5 text-[14px] rounded-md leading-none cursor-pointer transition-all border-1 bg-gray-300 text-white"
>See
        Commissions</span>
    </div>
  </div>
</template>


<script>


export default {

  components: {

  },

  props: ["item"],
  data() {
    return {

    };
  },
  computed: {

  },

  watch: {

  },

  mounted() {

  },

  methods: {
    getStatusImage(status) {
      switch (status) {
        case 'pending':
          return require('@/assets/images/pending-status.png');
        case 'approved':
          return require('@/assets/images/approved-green-icon.png');
        case 'rejected':
          return require('@/assets/images/reject-status.png');
        default:
          return require('@/assets/images/pending-status.png');
      }
    }
  },
};
</script>